import Vue from 'vue'
import I18n from 'vue-i18n'
import ch from './Chinese'
import en from './English'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
Vue.use(I18n)

export default new I18n({
    locale: localStorage.getItem('locale') || 'zh-cn',
    messages: {
        "zh-cn": Object.assign(ch, zhLocale),
        "en-us": Object.assign(en, enLocale)
    }
})


// WEBPACK FOOTER //
// ./src/i18n/index.js